import { error, finish } from '../../../modules/ladders/actions/getSportLadder';
import api from '../../../api';

export function request(dispatch, { sportId }) {
    // api.get(`/ladders/${sportId}`,  void 0, { cache: true }).then(
    //     ladder => dispatch(finish(sportId, ladder)),
    //     ({ errors }) => dispatch(error(sportId, errors))
    // );

    $appState.sdkStaff.trading.getPriceLadderByKey(sportId)
        .then(data => dispatch(finish(sportId, data)))
        .catch(errors => dispatch(error(sportId, errors)));
}
